import type { UseModalProps } from '@trinity/chat-components/components/Modal/index.js';
import { Modal, Header } from '@trinity/chat-components/components/Modal/index.js';
import ButtonSet from '@trinity/chat-components/components/Modal/ButtonSet.js';
import { ButtonActivityIndicator } from '@trinity/chat-components/components/presentation/index.js';
import { Button } from '@trinity/chat-components/components/presentation/Button/index.js';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { Editing as TagsForm } from '@trinity/chat-components/components/GroupSidebarTags/Tags.Editing.js';
import { useCallback, useContext } from 'react';
import { useGroupEntityTags, useGroupEntityTagsUpdate } from '@trinity/chat-components/contexts/group-tags/hooks/index.js';
import { GroupEntityTagsSavingContext } from '../../contexts';
import { GroupTagsStateContainer } from '../GroupSidebarTags/State.Container';
import { GroupTagsUpdateContext } from '../GroupSidebarTags/Context';
import { useGroupTags } from '../GroupSidebarTags/hooks';

type Props = {

} & UseModalProps;

const EditTagsModal = ({
  onClose,
  open,
}: Props) => {

  const isSaving = useContext(GroupEntityTagsSavingContext);
  const { tags } = useGroupTags();
  const [onSave, canSave] = useContext(GroupTagsUpdateContext);

  const handleSave = useCallback(async () => {
    try {
      await onSave(tags);
      onClose();
    } catch (error) {
      Toast.error({ title: 'Error saving tags' });
    }
  }, [onClose, onSave, tags]);

  return (
    <Modal disableOverlayClick={true} open={open} onClose={onClose}>
      <Header>Manage Tags</Header>
      <TagsForm />
      <ButtonSet>
        <Button
          variant='brick'
          color='destructive'
          onClick={onClose}>
          Cancel
        </Button>
        <ButtonActivityIndicator
          disabled={isSaving || !canSave}
          implicitDisable={false}
          loading={isSaving}
          onClick={handleSave}>
          Save
        </ButtonActivityIndicator>
      </ButtonSet>
    </Modal>
  );
};

const EditTagsModalContainer = (props: Props) => {

  const tags = useGroupEntityTags();
  const updateTags = useGroupEntityTagsUpdate();

  return (
    <GroupTagsStateContainer tags={tags} onSave={updateTags}>
      <EditTagsModal {...props} />
    </GroupTagsStateContainer >
  );
};

export { EditTagsModalContainer as EditTagsModal };